<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.name">
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      {{currency}}
      <vs-dropdown-menu class="w-48 vx-navbar-dropdown">
        <vs-dropdown-item @click="switchCurrency('BRL')">
          BRL
        </vs-dropdown-item>
        <vs-dropdown-item @click="switchCurrency('USD')">
          USD
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <p class="font-semibold">{{ activeUserInfo.name }}</p>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/user-settings').catch(() => {})"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Perfil</span>
          </li>

          <vs-divider class="m-1" />
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Sair</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currency: 'BRL'
    };
  },
  computed: {
    activeUserInfo() {
      return JSON.parse(localStorage.getItem('user'));
    }
  },
  mounted() {
    this.currency = localStorage.getItem('currency') || 'BRL'
  },
  methods: {
    switchCurrency(currencyCode) {
      localStorage.setItem('currency', currencyCode);
      window.location.reload()
    },
    logout() {
      localStorage.removeItem('user');
      this.$router.push('/pages/login').catch(() => {});
    }
  }
};
</script>
